import React from "react";
import "./styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { registerLocale, getNames } from "i18n-iso-countries";
import countriesES from "i18n-iso-countries/langs/es.json";

const FirstQuestionFormComponent = ({
  infoPatient,
  onChangeInfoPatient,
  questionResponse,
  setShowErrorModal,
  token,
}) => {
  const {
    name,
    address,
    city,
    phoneNumber,
    profession,
    dni,
    postalCode,
    province,
    email,
    birthdate,
    countryCode,
    gender,
  } = infoPatient;

  registerLocale(countriesES);

  const countryOptions = Object.entries(
    getNames("es", { select: "official" })
  ).map(([code, name]) => ({
    value: code,
    label: name,
  }));

  const location = useLocation();
  const navigate = useNavigate();

  const onChange = (event) => {
    const { value, name } = event.target;
    const updatedInfoPatient = {
      ...infoPatient,
      [name]: value,
    };

    onChangeInfoPatient(updatedInfoPatient);
  };

  const onClickMinorData = () => {
    questionResponse(5);
  };

  const onClickNextQuestion = () => {
    const isFormComplete = Object.values(infoPatient).every(
      (response) => response !== ""
    );

    if (isFormComplete) {
      questionResponse(2);
    } else {
      setShowErrorModal(true);
    }
  };

  const onClickNextCancelAppointment = () => {
    const newPathname =
      location.pathname.replace("/formulario", "/anular-cita-previa") +
      "?k=" +
      token;

    navigate(newPathname, { replace: true });
  };

  const renderInput = (label, inputName, inputValue) => {
    if (
      inputName !== "countryCode" &&
      inputName !== "birthdate" &&
      inputName !== "gender"
    ) {
      return (
        <>
          <p>{label}</p>
          <input
            type="text"
            className="inputFormComponent"
            name={inputName}
            value={inputValue}
            onChange={onChange}
          />
        </>
      );
    } else if (inputName === "countryCode") {
      return (
        <>
          <p>{label}</p>
          <select
            type="text"
            className="inputFormComponent"
            name={inputName}
            value={inputValue}
            onChange={onChange}
          >
            <option key="ES" value="ES">
              España
            </option>
            {countryOptions.map((country) => (
              <option key={country.value} value={country.value}>
                {country.label}
              </option>
            ))}
          </select>
        </>
      );
    } else if (inputName === "birthdate") {
      return (
        <>
          <p>{label}</p>
          <input
            type="date"
            className="inputFormComponent"
            name={inputName}
            value={inputValue}
            onChange={onChange}
          />
        </>
      );
    } else if (inputName === "gender") {
      return (
        <>
          <p>{label}</p>
          <select
            className="inputFormComponent"
            name={inputName}
            value={inputValue}
            onChange={onChange}
          >
            <option value="">Seleccione género</option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
            <option value="Otro">Otros</option>
            <option value="Prefiero no decirlo">Prefiero no decirlo</option>
          </select>
        </>
      );
    }
  };

  return (
    <div>
      <div className="firstQuestionFormComponent">
        <div className="column">
          {renderInput("Nombre y apellidos", "name", name)}
          {renderInput("Domicilio", "address", address)}
          {renderInput("Código postal", "postalCode", postalCode)}
          {renderInput("Población", "city", city)}
          {renderInput("Provincia", "province", province)}
          {renderInput("País", "countryCode", countryCode)}
        </div>
        <div className="column">
          {renderInput("DNI/NIF", "dni", dni)}
          {renderInput("Móvil", "phoneNumber", phoneNumber)}
          {renderInput("Email", "email", email)}
          {renderInput("Fecha de nacimiento", "birthdate", birthdate)}
          {renderInput("Género", "gender", gender)}
          {renderInput("Profesión", "profession", profession)}
        </div>
      </div>
      <div className="containerButtonsForm">
        <button className="btnForm" onClick={onClickNextCancelAppointment}>
          Anular cita
        </button>
        <button className="btnForm" onClick={onClickMinorData}>
          Soy menor de edad
        </button>
        <button className="btnForm" onClick={onClickNextQuestion}>
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default FirstQuestionFormComponent;
